import * as React from 'react'
import ShortcutAlert from '../../ui-kit/alerts/shortcut'
import { MAX_QUERY_LENGTH } from 'lib/preprocessQuery'

/**
 * Says that only the start of what was pasted has been translated.
 *
 * The box accepts any amount of text, but the translator takes
 * MAX_QUERY_LENGTH characters at a time — without this the rest simply
 * disappears, and the result looks like a translation of the whole thing.
 */
const QueryTruncatedAlert = () => (
   <div className="container text-center mx-auto">
      <ShortcutAlert
         isShown={true}
         title="Text shortened"
         background="#ff9800"
         color="#fff"
         icon="info_outline"
      >
         <span>
            Only about the first {MAX_QUERY_LENGTH} characters were translated. Try splitting longer
            text into smaller pieces.
         </span>
      </ShortcutAlert>
   </div>
)

export default QueryTruncatedAlert
